import { ReactNode } from 'react'
import cn from 'classnames/bind'

import PlainHelperText from 'app/common/ui-next/plain-helper-text/plain-helper-text'
import styles from './content-group.module.scss';


const cx = cn.bind(styles)

type Props = {
  children: ReactNode
  className?: string
  header?: string | ReactNode
  transparentBackground?: boolean
  babyHeader?: boolean
  normalHeader?: boolean
  error?: boolean
  helperText?: string
}

const ContentGroup = ({
  children,
  className,
  header,
  transparentBackground,
  babyHeader,
  normalHeader,
  error,
  helperText,
}: Props) => {
  const rootClassName = cx(styles.root, {
    background: !transparentBackground,
    error,
    isHelperText: !!helperText,
  }, className)

  const headerClassName = cx(styles.header, {
    babyHeader,
    strangeHeader: !babyHeader && !normalHeader,
    normalHeader,
  })

  return (
    <div className={rootClassName}>
      {header
        && <h3 className={headerClassName}>
          {header}
        </h3>}
      {children}

      {helperText
        && <PlainHelperText className={styles.helperText} error={error}>
          {helperText}
        </PlainHelperText>}
    </div>
  )
}

export default ContentGroup
